import { render, staticRenderFns } from "./Goodkinds.vue?vue&type=template&id=7ecb5794&scoped=true&"
import script from "./Goodkinds.vue?vue&type=script&lang=js&"
export * from "./Goodkinds.vue?vue&type=script&lang=js&"
import style0 from "./Goodkinds.vue?vue&type=style&index=0&id=7ecb5794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecb5794",
  null
  
)

export default component.exports